import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import HeaderBar from '../HeaderBar';
import SideBar from '../SideBar';
import './style.css';

export default function Layout() {
  return (
    <>
      <div className="layout-container">
        <header className="headerbar">
          <HeaderBar />
        </header>

        <aside className="sidebar">
          <SideBar />
        </aside>

        <main className="main-content">
          <Outlet />
        </main>

        <footer className="footer">
          <Footer />
        </footer>
      </div>
    </>
  );
}
